module.exports = __webpack_public_path__ + "static/media/favicon.ca4be9fa.ico";